import { Button, Grid, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { ViewBillingAddressDto } from '../../../lib/api/addresses/dto/view-billing-address.dto';
import { AddressType } from '../../../lib/api/addresses/enums/address-type.enum';
import useAuth from '../../../lib/api/auth/useAuth';
import { ViewCustomerExtendedDto } from '../../../lib/api/customers/dto/view-customer-extended.dto';
import { CreateOrderDto } from '../../../lib/api/orders/dto/create-order.dto';
import RhfAutocomplete from '../../ui/forms/RhfAutocomplete';

interface Props {
  customer: ViewCustomerExtendedDto;
  onClickAddAddress: () => void;
}

export default function BillingAddressPartial({
  customer,
  onClickAddAddress,
}: Props) {
  const {
    formState: { errors },
    control,
  } = useFormContext<CreateOrderDto>();

  const { loggedInUser } = useAuth();

  if (!customer) return;

  const billingAddresses = customer.addresses.filter(
    (a) => a.type === AddressType.billing,
  );

  const billingAddressDisplayFn = (a: ViewBillingAddressDto) => {
    const displayValue = `${a.street1 || ''} 
      ${a.street2 || ''} 
      ${a.poBox || ''} 
      ${a.city || ''}, 
      ${a.state || ''} 
      ${a.zip || ''} ${a.code ? `(${a.code})` : ''} `;
    return displayValue.replace(/\s\s+/g, ' ');
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography component="h2" variant="h5">
          Which location should be billed for this order?
        </Typography>
      </Grid>

      {billingAddresses && (
        <Grid item xs={12} sm={12} md={12}>
          <RhfAutocomplete
            control={control}
            name="billingAddressId"
            defaultText="Select Billing Address"
            optionsAsArray={billingAddresses}
            displayTextFn={billingAddressDisplayFn}
            required
          />
        </Grid>
      )}
      {loggedInUser.isAdmin && (
        <Grid item xs={12} display="flex" justifyContent="flex-end">
          <Button onClick={onClickAddAddress}>
            Create New Billing Address
          </Button>
        </Grid>
      )}
    </Grid>
  );
}
